@if (data['selector'] != undefined) {
  <ng-template #customComponent>
  </ng-template>
}
@if (data['selector'] == undefined) {
  <dhs-form [action]="'ADD'" [fieldGroup]="_currentData._currentFormFields" [config]="config" [formtype]="'popup'"
    [customButton]='btn' [data]="_currentData._currentData" [decorator]="_currentData.decorator"
    (saveFinished)="onSaveFinished($event)" (cancel)="closePopUp()">
  </dhs-form>
}